class ReadMoreDesc extends HTMLElement {
  constructor() {
    super()

    this.trigger = this.querySelector('.read-more-desc__trigger')
    this.copy = this.querySelector('.everyday-operator-template__copy')
    this.initialiseReadMoreDesc()

  }

  initialiseReadMoreDesc() {
    this.trigger.addEventListener('click', () => {
      this.copy.classList.toggle('everyday-operator-template__copy--open')
      if (this.copy.classList.contains('everyday-operator-template__copy--open')) {
        this.trigger.innerHTML = 'Read Less'
      } else {
        this.trigger.innerHTML = 'Read More'
      }
    })  
  }

}

customElements.define('read-more-desc', ReadMoreDesc)